import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PepperPayAccount } from 'components/pepper-pay/model/PepperPay';

export enum StripeSignUpStatus {
    UNKNOWN = 'UNKNOWN',
    NO_ACCOUNT = 'NO_ACCOUNT',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED'
}

export interface StripeSettingsState {
    loading: boolean;
    error?: string;
    locationId?: string;
    showLocationPicker?: boolean;
    account?: PepperPayAccount;
    status: StripeSignUpStatus;
}

export const initialState: StripeSettingsState = {
    loading: true,
    error: undefined,
    locationId: undefined,
    showLocationPicker: true,
    account: undefined,
    status: StripeSignUpStatus.UNKNOWN
};

const stripeSettingsSlice = createSlice({
    name: 'stripeSettings',
    initialState,
    reducers: {
        startRequest: state => {
            state.loading = true;
        },
        endRequest: state => {
            state.loading = false;
        },
        setStripeSettingsError: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
        setStripeSettingsLocation: (state, action: PayloadAction<string>) => {
            state.locationId = action.payload;
        },
        setStripeLocationPickerOpen: (state, action: PayloadAction<boolean>) => {
            state.showLocationPicker = action.payload;
        },
        setStripeSignupStatus: (state, action: PayloadAction<StripeSignUpStatus>) => {
            state.status = action.payload;
        },
        softResetStripeSettings: state => {
            const { loading } = state;
            return { ...initialState, loading };
        },
        setStripeAccount: (state, action: PayloadAction<PepperPayAccount | undefined>) => {
            state.account = action.payload;
        }
    }
});

export const {
    startRequest,
    endRequest,
    setStripeSettingsError,
    setStripeSettingsLocation,
    setStripeLocationPickerOpen,
    setStripeSignupStatus,
    softResetStripeSettings,
    setStripeAccount
} = stripeSettingsSlice.actions;
export default stripeSettingsSlice.reducer;
